import cx from 'classnames';
import React from 'react';
/* Components */
export const List = ({ caption, children, className, is: Tag = 'ul', light, variant, ...rest }) => (React.createElement(Tag, { className: cx('tds-list', {
        [`tds-list--${variant}`]: variant,
        'tds-list--light': light,
        'tds-list--caption': caption,
    }, className), ...rest }, children));
